module.exports = __webpack_public_path__ + "img/namn-frida.fba9a894.svg";